<template>
  <div>
    <a-card>
      <h6 class="text-bold">Filters</h6>
      <a-row class="mobile-wrapper">
        <slot name="inputFields"></slot>
        <a-col :span="4" class="mt-2 mobile-full-width">
          <button @click="filter" class="btn">Filter {{name}}</button>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    name: String
  },
  methods: {
    filter() {
      this.$emit("filter");
    }
  }
};
</script>
